import classNames from 'classnames';
import styles from './FieldFeedback.module.scss';

export const FieldFeedbackVariant = {
    Info: 'info',
    Error: 'error',
    Success: 'success',
    Warning: 'warning',
} as const;

export type FieldFeedbackVariantType =
    (typeof FieldFeedbackVariant)[keyof typeof FieldFeedbackVariant];

type FieldFeedbackProps = {
    variant: FieldFeedbackVariantType;
    children: React.ReactNode;
    className?: string;
    id?: string;
    'data-testid'?: string;
};

const getRole = (variant: FieldFeedbackVariantType) => {
    if (variant === FieldFeedbackVariant.Error) {
        return 'alert';
    }

    if (variant === FieldFeedbackVariant.Success || variant === FieldFeedbackVariant.Warning) {
        return 'status';
    }

    return undefined;
};

const FieldFeedback = ({
    variant,
    children,
    className,
    id,
    'data-testid': dataTestId,
}: FieldFeedbackProps) => (
    <p
        id={id}
        data-testid={dataTestId}
        role={getRole(variant)}
        className={classNames(styles.feedback, styles[variant], className)}
    >
        {children}
    </p>
);

export default FieldFeedback;
